export const isLpApiEndpoint = (apiEndpoint: string): boolean => Boolean(process.env.REACT_APP_LP_API_BASE_URL && apiEndpoint.startsWith(process.env.REACT_APP_LP_API_BASE_URL));
